import { gql, TypedDocumentNode } from "@apollo/client";

export type PersonExistsQueryData = {
  person: { id: string; pgaId: string } | null;
};

export type PersonExistsQueryVariables = {
  pgaId: string;
};

export const PERSON_EXISTS_QUERY: TypedDocumentNode<PersonExistsQueryData, PersonExistsQueryVariables> = gql`
  query PersonExistsForCcmsLookup($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      pgaId
    }
  }
`;
